
// This gets set to the global app object
export var gApp = null

// List of route names that can be accessed while signed out
/*
export let kSignedOutRoutes = [
  'home',
  'signin',
  'signup',
  'psychrometrics',
  'solar-calculator',
  'FirebaseAction',
]
*/

export function setGlobalApp(app) {
  gApp = app;
}

export function DebugOn() {
  return gApp.proj().debugOn; 
}

export var gIsTestEnv = false;

export function setTestEnv(isTestEnv) {
  gIsTestEnv = isTestEnv;
}

export function IsTestEnv() {
  return gIsTestEnv;
}